import { useEffect, useState } from "react";
import { Globe, Plug, FileText } from "lucide-react";
import { Card } from "@/components/common/PageHeader";
import { Loading, Stat } from "@/pages/_shared";
import { toast } from "sonner";
import api from "@/lib/api";

export default function WebsitesFunnels() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/websites/overview").then(({ data }) => setData(data)); }, []);
  if (!data) return <Loading />;
  const { pages, stats, connections } = data;

  return (
    <div className="animate-fade-up space-y-6" data-testid="websites-page">
      <div>
        <h1 className="flex items-center gap-2 font-head text-2xl font-extrabold tracking-tight text-slate-900"><Globe size={22} className="text-[#b0862f]" /> Websites & Funnels</h1>
        <p className="mt-1 text-[13px] text-slate-500">The pages your AI Web Developer maintains in Content Studio. Connect hosting and forms below to publish to a live domain and capture leads.</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-3">
        <Stat label="Pages" value={stats.pages} tone="slate" />
        <Stat label="Published" value={stats.published} tone="green" />
        <Stat label="Drafts" value={stats.drafts} tone="blue" />
      </div>

      <Card className="p-5" data-testid="websites-connections">
        <div className="mb-3 flex items-center gap-2"><Plug size={15} className="text-amber-500" /><span className="font-head text-[14px] font-bold text-slate-900">Connections</span></div>
        <div className="grid gap-2 sm:grid-cols-3">
          {connections.map((c) => (
            <div key={c.name} className="rounded-lg border border-dashed border-amber-300 bg-amber-50/40 p-3" data-testid="website-connection">
              <div className="text-[13px] font-semibold text-slate-800">{c.name}</div>
              <div className="mt-0.5 font-mono text-[10px] text-slate-500">{c.purpose}</div>
              <button onClick={() => toast.message("Integration required", { description: `Connect ${c.name} — needs ${c.needs}.` })} data-testid="website-setup-btn" className="mt-2 w-full rounded-lg bg-[#080d1a] px-3 py-1.5 text-[12px] font-bold text-white hover:bg-[#1a5fd0]">Set up</button>
            </div>
          ))}
        </div>
      </Card>

      <Card className="p-5" data-testid="websites-pages">
        <div className="mb-3 flex items-center gap-2"><FileText size={15} className="text-[#1a5fd0]" /><span className="font-head text-[14px] font-bold text-slate-900">Site pages</span></div>
        {pages.length === 0 ? <div className="py-6 text-center text-[13px] text-slate-400">No pages yet. Create them in Content Studio.</div> : (
          <div className="space-y-2">
            {pages.map((p) => (
              <div key={p.slug} className="flex items-center justify-between rounded-lg border border-slate-100 px-3 py-2.5 text-[13px]" data-testid="website-page-row">
                <div><span className="font-semibold text-slate-800">{p.title}</span><span className="ml-2 font-mono text-[11px] text-slate-400">/{p.slug} · v{p.version}</span></div>
                <span className={`rounded-full px-2 py-0.5 font-mono text-[9px] font-bold uppercase ${p.status === "Published" ? "bg-emerald-50 text-emerald-600" : "bg-slate-100 text-slate-500"}`}>{p.status}</span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
